// Auth0 Google Workspace connection for staff; Universal Login routes these emails here by domain.
export const JOY_SSO_CONNECTION = 'withjoy.com';

export const isJoySsoEmail = (email?: string): boolean => !!email && email.trim().toLowerCase().endsWith('@withjoy.com');
